export default __webpack_public_path__ + "3b19346c049dfe306a72a70b9dcfa744.png";